import React, { memo } from 'react';
import { Tooltip, Typography, IconButton, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@material-ui/icons/Delete';
import { useStyles } from '../DiagnosticRevisionTable.style';
import { MICROCALC_CLUSTERABLE } from '../constants/constants';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const RowActions = ({
  lesionAllInfo,
  isGrouped = false,
  isHovered = false,
  nested = false,
  onDelete,
  pinnedRow,
  setPinnedRow,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const finding_class = lesionAllInfo?.finding_class;
  const module_type = lesionAllInfo?.module_type;
  const rowPinId =
    isGrouped || lesionAllInfo?.isMatchedMainRow ? lesionAllInfo?.object_id : lesionAllInfo?.finding_id;
  const isPinned = !!pinnedRow && pinnedRow === rowPinId;

  const showEyeIcon = () => {
    if (nested) return false;

    if (module_type === 'microcalc') {
      return MICROCALC_CLUSTERABLE.includes(finding_class);
    }

    return false;
  };

  const isClassClustered = showEyeIcon();

  return (
    <div
      className={`${classes.action_icons_container} row-actions-class`}
      id='row-actions'
      data-no-drag='true'>
      {/* VISIBILITY  */}
      {isClassClustered && (
        <div className={classes.empty_actions_container} data-no-drag='true'>
          <IconButton
            className={classes.row_actions_icon}
            data-no-drag='true'
            size='small'
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              if (!setPinnedRow) return;
              setPinnedRow((prevPinnedRow) => (prevPinnedRow === rowPinId ? null : rowPinId));
            }}>
            {isHovered || isPinned ? (
              <VisibilityIcon fontSize='small' style={{ width: '14px', height: '14px', margin: '2px 0' }} />
            ) : (
              <VisibilityOffIcon
                fontSize='small'
                style={{ width: '14px', height: '14px', margin: '2px 0', fill: 'gray' }}
              />
            )}
          </IconButton>
        </div>
      )}
      {/* DELETE   */}
      <div className={classes.empty_actions_container} data-no-drag='true'>
        {isHovered && (
          <Tooltip
            title={
              <Typography className={classes.tooltip_text}>
                {lesionAllInfo?.matched_lesions || lesionAllInfo?.isMatchedMainRow
                  ? t('revision.delete_matched')
                  : isGrouped
                  ? t('revision.delete_grouped')
                  : t('revision.delete_single')}
              </Typography>
            }
            placement='right-start'
            arrow>
            <IconButton
              className={classes.row_actions_icon}
              data-no-drag='true'
              id='row-delete-icon'
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onDelete?.(lesionAllInfo, isGrouped, e);
              }}
              size='small'>
              <DeleteIcon fontSize='small' style={{ width: '14px', height: '14px' }} />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default memo(RowActions);
